<template>
  <BasePanel title="Utility Payments">
    <div class="d-flex flex-column fill-height" style="overflow-y: auto">
      <div class="d-flex justify-space-around flex-none">
        <div
          class="utility-item"
          :key="key"
          v-for="(utility, key) of utilities"
        >
          <img
            @click="goToPage(utility)"
            class="utility-image touchable-scale"
            :src="utility.url"
          />
          <div>{{ utility.name }}</div>
        </div>
      </div>
    </div>
  </BasePanel>
</template>

<script>
import BasePanel from "@/components/BasePanel";

export default {
  components: {
    BasePanel
  },

  data() {
    return {
      utilities: [
        {
          name: "Challan",
          url: require(`@/assets/images/challan.png`)
        },
        {
          name: "MC",
          url: require(`@/assets/images/imc.png`)
        },
        {
          name: "Electricity",
          url: require(`@/assets/images/elictrict.png`),
          link: "https://www.arpdop.gov.in"
        },
        {
          name: "Water",
          url: require(`@/assets/images/water.png`)
        }
      ]
    };
  },

  methods: {
    goToPage(utility) {
      if (utility.link) {
        window.open(utility.link);
      }
    }
  }
};
</script>

<style scoped>
.utility-item {
  color: #999;
  text-align: center;
}

.wrap-image {
  background-color: #fff;
}

.header {
  background-color: var(--primary);
  padding: 1em !important;
}

.text-left {
  padding-right: 1.875em;
}

.d-flex justify-space-around {
  display: flex;
  flex-wrap: wrap;
}

.utility-image {
  height: 2.5em;
  width: auto;
}
</style>
